// tabs/CommTab.jsx - Communication/Commission tab
import React, { useState } from 'react';
import { Box, Grid, Stack, TextInput, Group, Text, NumberInput } from '@mantine/core';

const CommTab = ({ selectedLineId }) => {
  const [commData, setCommData] = useState({
    salespersonAccounts: [
      { name: 'Derek Deur', percentage: 3.0000, amount: 0.00 },
      { name: '', percentage: 0.0000, amount: 0.00 },
      { name: '', percentage: 0.0000, amount: 0.00 },
      { name: '', percentage: 0.0000, amount: 0.00 },
      { name: '', percentage: 0.0000, amount: 0.00 }
    ],
    assignedBuyer: ''
  });

  const handleSalespersonChange = (index, field, value) => {
    const newSalespersonAccounts = [...commData.salespersonAccounts];
    newSalespersonAccounts[index] = {
      ...newSalespersonAccounts[index],
      [field]: value
    };
    setCommData(prev => ({
      ...prev,
      salespersonAccounts: newSalespersonAccounts
    }));
  };

  const handleBuyerChange = (value) => {
    setCommData(prev => ({ ...prev, assignedBuyer: value }));
  };

  return (
    <Box p="md">
      <Grid gutter="md">
        <Grid.Col span={12}>
          {/* Salesperson Accounts Section */}
          <Box mb="md">
            <Text size="sm" fw={500} mb="sm">Salesperson Accounts</Text>
            
            <Stack spacing="xs">
              {commData.salespersonAccounts.map((salesperson, index) => (
                <Group key={index} spacing="xs" align="flex-end">
                  <Text size="sm" fw={500} w={30}>[{index + 1}]:</Text>
                  <TextInput
                    value={salesperson.name}
                    variant="filled"
                    size="sm"
                    style={{ width: '200px' }}
                    styles={index === 0 ? { input: { fontWeight: 'bold', color: 'blue' } } : {}}
                    onChange={(e) => handleSalespersonChange(index, 'name', e.target.value)}
                  />
                  <NumberInput
                    value={salesperson.percentage}
                    variant="filled"
                    size="sm"
                    w={80}
                    styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                    decimalScale={4}
                    fixedDecimalScale
                    onChange={(value) => handleSalespersonChange(index, 'percentage', value)}
                  />
                  <Text size="sm" fw={500}>%</Text>
                  <NumberInput
                    value={salesperson.amount}
                    variant="filled"
                    size="sm"
                    w={80}
                    styles={{ input: { textAlign: 'right', fontWeight: 'bold', color: 'blue' } }}
                    decimalScale={2}
                    fixedDecimalScale
                    onChange={(value) => handleSalespersonChange(index, 'amount', value)}
                  />
                </Group>
              ))}
            </Stack>
          </Box>

          {/* Assigned Buyer Section */}
          <Box mt="lg">
            <Group spacing="xs" align="flex-end">
              <Text size="sm" fw={500} w={120}>Assigned Buyer:</Text>
              <TextInput
                value={commData.assignedBuyer}
                variant="filled"
                size="sm"
                style={{ width: '200px' }}
                onChange={(e) => handleBuyerChange(e.target.value)}
              />
            </Group>
          </Box>
        </Grid.Col>
      </Grid>
    </Box>
  );
};

export default CommTab;